import type { PermissionDto, UserRoleDto, UserStatusDto } from '@/types/auth/auth.types'

export type UserRole = UserRoleDto
export type UserStatus = UserStatusDto
export type Permission = PermissionDto

export interface CurrentUser {
  id: string
  firstName: string
  lastName: string
  email: string
  role: UserRole
  status: UserStatus
  permissions: readonly Permission[]
}

export function hasPermission(
  user: Pick<CurrentUser, 'permissions'> | null | undefined,
  permission: Permission,
): boolean {
  return user?.permissions.includes(permission) ?? false
}
